const state = {
  commentsList: []
}

export default state
